import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Button, CardFooter, CardHeader, CardBody } from "reactstrap";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import photoIcon from "../../../assets/images/photoIcon.png";
import commentIcon from "../../../assets/images/commentIcon.png";
import { Card } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Spin } from "antd";
import "../utils/style.css";
import {
  CheckOutlined,
  CloseOutlined,
  IssuesCloseOutlined,
} from "@ant-design/icons";
import InspectionResponse from "./InspResponse";
import { useTranslation } from "react-i18next";

const InspectionItem = ({ inspection, user }) => {
  const { id } = useParams();
  const [openRevisionId, setOpenRevisionId] = useState(null);
  const {t} = useTranslation();
    const toggleOpen = (id) => {
    setOpenRevisionId(openRevisionId === id ? null : id);
  };

  const [isModalOpen, setIsModalOpen] = useState("");
  const [selectedInspection, setSelectedInspection] = useState(null);

  const toggleResponseModal = (inspection) => {
    setSelectedInspection(inspection);
    setIsModalOpen(!isModalOpen);
  };

  const statutCount = inspection?.revisions?.filter(
    (revision) => revision.status
  ).length;
  const countOui = inspection?.revisions?.filter(
    (revision) => revision.status.toLowerCase() === "oui"
  ).length;
  const countNon = inspection?.revisions?.filter(
    (revision) => revision.status.toLowerCase() === "non"
  ).length;

  return (
    <div>
      <Card>
        <CardHeader>
        
          <div className="insp-section-title">
            {inspection?.typeInspection || "Type non défini"}
          </div>
          <div className="d-flex justify-content-between w-100">
            <div className="text-center">
              <p className="inspection-section-title">
                <IssuesCloseOutlined /> {t("inspections.total")}({statutCount || "-"})
              </p>
            </div>

            <div className="text-center" >
              <p className="inspection-section-title" style={{ color: "#269B44" }}>
                <CheckOutlined />{t("inspections.bon")}  ({countOui || "-"}){" "}
              </p>
            </div>

            <div className="text-center" >
              <p className="inspection-section-title" style={{ color: "#DE1515" }}>
                <CloseOutlined />{t("inspections.mauvais")}  ({countNon || "-"})
              </p>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {inspection?.revisions && inspection?.revisions.length > 0 ? (
            inspection.revisions.map((rev, index) => (
              <div key={index}>
                <Row>
                  <Col md={3} className="insp-revision-title">
                    {rev?.name || "-"} {"  "}
                    {rev?.fileName && (
                      <span
                        onClick={() => toggleOpen(index)}
                        className="insp-toggle-btn"
                      >
                        {openRevisionId === index ? (
                          <FaChevronUp size={10} color="dark" />
                        ) : (
                          <FaChevronDown size={10} color="dark" />
                        )}
                      </span>
                    )}
                  </Col>
                  {rev?.fileName ? (
                    <>
                      <Col md={3} className=" insp-photo-revsion">
                        <img
                          src={photoIcon}
                          alt="Photo"
                          className="insp-photo-btn"
                        />{" "}
                        {t("inspections.photo")}
                      </Col>
                      <Col md={3} className=" insp-photo-revsion">
                        <img
                          src={commentIcon}
                          alt="Commentaire"
                          className="insp-comment-btn"
                        />{" "}
                       {t("inspections.comment")}
                      </Col>
                    </>
                  ) : (
                    <Col  />
                  )}
                  <Col
                    md={3}
                    className="insp-revision-status "
                    style={{
                      color:
                        rev?.status === "Oui"
                          ? "#269B44"
                          : rev?.status === "Non"
                          ? "#DE1515"
                          : "gray",
                    }}
                  >
                    {rev?.status}
                  </Col>
                </Row>
                <hr className="insp-hr" />
                {rev?.fileName && openRevisionId === index && (
                  <div className="insp-revision-details">
                    <div>{rev?.description}</div>
                    <Row>
                      <Col>
                        <img
                          src={
                            `${process.env.REACT_APP_API_MEDIA_URL}/print/${rev?.fileName}` ||
                            avatar1
                          }
                          alt=""
                          className="insp-revision-image"
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>{t("inspections.notFound")}</p>
          )}
        </CardBody>
        <CardFooter >
          <Button
            className="buttonAdd"
            title="Répondre à cette inspection"
            onClick={() => toggleResponseModal(inspection)}
          >
            {t("inspections.repond")}
    
          </Button>
        </CardFooter>
      </Card>
      {isModalOpen && (
        <InspectionResponse
          modal={isModalOpen}
          setModal={setIsModalOpen}
          toggle={toggleResponseModal}
          selectedInspection={selectedInspection}
        />
      )}
    </div>
  );
};

export default InspectionItem;
